import { AxiosRequestConfig } from 'axios';
import { RestApi } from '../../common/services';
import { store } from '../../common/store/store';
import { downloadFile } from '../../common/utils';
import { CreateOrderValues, Order, OrderOptions } from '../types';

const buildingId = () => store.getState().security.ui.buildingId;

export const getOrderOptions = async (): Promise<OrderOptions> =>
  await RestApi.get<never, OrderOptions>(`/building/${buildingId()}/order-options`);

/** 409 = na produkt už čeká nezaplacená objednávka (volající přesměruje na její stav). */
export const createOrder = async (values: CreateOrderValues): Promise<Order> =>
  await RestApi.post<CreateOrderValues, Order>(`/building/${buildingId()}/order`, values);

export const getOrder = async (orderId: string): Promise<Order> =>
  await RestApi.get<never, Order>(`/building/${buildingId()}/order/${orderId}`);

export const downloadOrderDocument = async (
  orderId: string,
  document: 'proforma' | 'tax-document',
  filename: string
): Promise<void> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    responseType: 'blob',
    url: `/building/${buildingId()}/order/${orderId}/${document}.pdf`,
  };

  return await RestApi.axios(config).then((res) => {
    downloadFile({ data: res.data, filename, mime: 'application/pdf' });
  });
};

/** QR Platba k vystavené proformě (stejný kód jako v e-mailu); 404 = proforma nemá použitelný účet. */
export const fetchOrderPaymentQrUrl = async (orderId: string): Promise<string> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    responseType: 'blob',
    url: `/building/${buildingId()}/order/${orderId}/payment-qr.png`,
  };

  const res = await RestApi.axios(config);
  return URL.createObjectURL(res.data);
};
